import { render, staticRenderFns } from "./FormLabel.vue?vue&type=template&id=63ed5d70"
import script from "./FormLabel.vue?vue&type=script&lang=js"
export * from "./FormLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/al-khaleej/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63ed5d70')) {
      api.createRecord('63ed5d70', component.options)
    } else {
      api.reload('63ed5d70', component.options)
    }
    module.hot.accept("./FormLabel.vue?vue&type=template&id=63ed5d70", function () {
      api.rerender('63ed5d70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/form/FormLabel.vue"
export default component.exports